import { render, staticRenderFns } from "./LanceInicial.vue?vue&type=template&id=925bb23e"
import script from "./LanceInicial.vue?vue&type=script&lang=js"
export * from "./LanceInicial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports